export const LANGUAGE = {
  en: "english",
  es: "español",
};
